"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _togaPortal = _interopRequireDefault(require("@thinkific/toga-portal"));

var _Toast = _interopRequireDefault(require("./Toast"));

var _constants = require("./constants");

var _EventManager = _interopRequireDefault(require("./EventManager"));

var _toaster = _interopRequireDefault(require("./toaster"));

var _Toast2 = _interopRequireDefault(require("./Toast.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_Toast2["default"]);
/* eslint-disable no-unused-expressions, no-restricted-globals, no-param-reassign */


var ToastContainer = /*#__PURE__*/function (_Component) {
  _inherits(ToastContainer, _Component);

  var _super = _createSuper(ToastContainer);

  _createClass(ToastContainer, null, [{
    key: "canBeRendered",
    value: function canBeRendered(content) {
      return (0, _react.isValidElement)(content) || typeof content === 'string' || typeof content === 'number' || typeof content === 'function';
    }
    /**
     * Hold toast's informations:
     * - what to render
     * - position
     * - raw content
     * - options
     */

  }]);

  function ToastContainer(props) {
    var _this;

    _classCallCheck(this, ToastContainer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "collection", {});

    _defineProperty(_assertThisInitialized(_this), "isDocumentHidden", function () {
      return _this.setState({
        isDocumentHidden: document.hidden
      });
    });

    _this.state = {
      // Hold toast ids
      toast: [],
      isDocumentHidden: false
    };
    return _this;
  }

  _createClass(ToastContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var pauseOnVisibilityChange = this.props.pauseOnVisibilityChange;
      var SHOW = _constants.ACTION.SHOW,
          CLEAR = _constants.ACTION.CLEAR,
          MOUNTED = _constants.ACTION.MOUNTED;

      _EventManager["default"].on(SHOW, function (content, options) {
        _this2.show(content, options);
      }).on(CLEAR, function (id) {
        return id !== null ? _this2.removeToast(id) : _this2.clear();
      }).emit(MOUNTED, this);

      pauseOnVisibilityChange && document.addEventListener('visibilitychange', this.isDocumentHidden);

      if (window.Thinkific) {
        window.Thinkific.toaster = _toaster["default"];
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var pauseOnVisibilityChange = this.props.pauseOnVisibilityChange;

      _EventManager["default"].off(_constants.ACTION.SHOW);

      _EventManager["default"].off(_constants.ACTION.CLEAR);

      pauseOnVisibilityChange && document.removeEventListener('visibilitychange', this.isDocumentHidden);
    }
  }, {
    key: "getAutoCloseDelay",
    value: function getAutoCloseDelay(toastAutoClose) {
      var autoClose = this.props.autoClose;
      return toastAutoClose === false || typeof toastAutoClose === 'number' && !isNaN(toastAutoClose) && toastAutoClose > 0 ? toastAutoClose : autoClose;
    }
  }, {
    key: "removeToast",
    value: function removeToast(id) {
      var toast = this.state.toast;
      this.setState({
        toast: toast.filter(function (v) {
          return v !== parseInt(id, 10);
        })
      });
    }
  }, {
    key: "show",
    value: function show(content, options) {
      var _this3 = this;

      if (!ToastContainer.canBeRendered(content)) {
        throw new Error("The element you provided cannot be rendered. You provided an element of type ".concat(_typeof(content)));
      }

      var toastId = options.toastId;

      var closeToast = function closeToast() {
        return _this3.removeToast(toastId);
      };

      var toast = this.state.toast,
          closeOnClick = this.props.closeOnClick;
      var toastOptions = {
        actionTitle: options.actionTitle,
        autoClose: this.getAutoCloseDelay(options.autoClose !== false ? parseInt(options.autoClose, 10) : options.autoClose),
        closeToast: closeToast,
        closeOnClick: options.closeOnClick !== null ? options.closeOnClick : closeOnClick,
        id: toastId,
        onActionClick: options.onActionClick,
        type: options.type,
        updateId: options.updateId
      };
      typeof options.onOpen === 'function' && (toastOptions.onOpen = options.onOpen);
      typeof options.onClose === 'function' && (toastOptions.onClose = options.onClose);

      if ((0, _react.isValidElement)(content) && typeof content.type !== 'string' && typeof content.type !== 'number') {
        content = (0, _react.cloneElement)(content, {
          closeToast: closeToast
        });
      } else if (typeof content === 'function') {
        content = content({
          closeToast: closeToast
        });
      }

      this.collection = _objectSpread({}, this.collection, _defineProperty({}, toastId, {
        options: toastOptions,
        content: content
      }));
      this.setState({
        toast: toastOptions.updateId !== null ? _toConsumableArray(toast) : [].concat(_toConsumableArray(toast), [toastId])
      });
    }
  }, {
    key: "makeToast",
    value: function makeToast(content, options) {
      var isDocumentHidden = this.state.isDocumentHidden;

      var isReactElement = _react["default"].isValidElement(content);

      return /*#__PURE__*/_react["default"].createElement(_Toast["default"], _extends({}, options, {
        isDocumentHidden: isDocumentHidden,
        key: "toast-".concat(options.id)
      }), isReactElement && content, !isReactElement &&
      /*#__PURE__*/

      /* eslint-disable-next-line react/no-danger */
      _react["default"].createElement("span", {
        dangerouslySetInnerHTML: {
          __html: content
        }
      }));
    }
  }, {
    key: "clear",
    value: function clear() {
      this.setState({
        toast: []
      });
    }
  }, {
    key: "renderToast",
    value: function renderToast() {
      var _this4 = this;

      var toastToRender = [];
      var stateToast = this.state.toast,
          collection = this.collection;
      Object.keys(collection).forEach(function (toastId) {
        var toast = _this4.collection[toastId];

        if (stateToast.indexOf(parseInt(toastId, 10)) !== -1) {
          if (toastToRender.length >= _constants.MAX_LIMIT) {
            toastToRender.shift();
          }

          toastToRender.push(_this4.makeToast(toast.content, toast.options));
        } else {
          delete _this4.collection[toastId];
        }
      });
      return toastToRender;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_togaPortal["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('toast__container')
      }, this.renderToast()));
    }
  }]);

  return ToastContainer;
}(_react.Component);

ToastContainer.propTypes = {
  /**
   * Disable or set autoClose delay
   */
  autoClose: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].bool]),

  /**
   * Dismiss toast on click
   */
  closeOnClick: _propTypes["default"].bool,
  // eslint-disable-line react/boolean-prop-naming

  /**
   * pause on document visibility change
   */
  pauseOnVisibilityChange: _propTypes["default"].bool // eslint-disable-line react/boolean-prop-naming

};
ToastContainer.defaultProps = {
  autoClose: 3000,
  closeOnClick: true,
  pauseOnVisibilityChange: true
}; // force bump

var _default = ToastContainer;
exports["default"] = _default;